import { getNavIdFromTitle } from '@bob/library'
import { StepContent } from '@websrc/App/Components/Lesson/Steps/StepContent'
import { mapSteps } from '@websrc/DataMappers/mapStepsContent'
import React from 'react'
import { match } from 'ts-pattern'

import * as SC from './Steps.style'

export type Step = ReturnType<typeof mapSteps>

export interface StepsProps {
  steps: Step[]
}

export const Steps = ({ steps }: StepsProps) => (
  <>
    {steps.map((step, key) => (
      <SC.StepWrapper key={key}>
        {match(step)
          .with({ __dataType: 'lessonStep' }, ({ title, type_and_timing, content }) => (
            <div data-testid={'lesson_step'}>
              <SC.Title id={getNavIdFromTitle(title)}>{title}</SC.Title>
              {type_and_timing && <SC.Subtitle>({type_and_timing})</SC.Subtitle>}
              {content.map((c, k) => (
                <StepContent content={c} key={k} />
              ))}
            </div>
          ))
          .with({ __dataType: 'worksheetStep' }, ({ title, content, hint }) => (
            <div data-testid={'student_worksheet_steps'}>
              <SC.Title id={getNavIdFromTitle(title)}>{title}</SC.Title>
              {content.map((c, k) => (
                <StepContent content={c} key={k} />
              ))}
              {hint.map((h, k) => (
                <SC.Hints key={k}>
                  <StepContent content={h} />
                </SC.Hints>
              ))}
            </div>
          ))
          .otherwise(() => null)}
      </SC.StepWrapper>
    ))}
  </>
)
